export default __webpack_public_path__ + "static/cli_jumbo-65e4ced949ecf10c64b52391e4795fd4.png";